import AdminEventtypesPageComponent from "./components/AdminEventtypesPageComponent";

import axios from "axios";

const fetchEventtypes = async (abctrl) => {
    const {data} = await axios.get("/api/eventtypes", {
        signal: abctrl.signal,
    });
    return data
}

const deleteEventtype = async (userId) => {
    const { data } = await axios.delete(`/api/eventtypes/${userId}`);
    return data
}

const AdminEventtypesPage = () => {
  return <AdminEventtypesPageComponent fetchEventtypes={fetchEventtypes} deleteEventtype={deleteEventtype} />;
};

export default AdminEventtypesPage;